export default [{
  type: 'email',
  placeholder: 'Email',
  key: 'forgotPasswordEmail',
  name: 'email'
}]
